import * as CryptoJS from 'crypto-js'
import store from '@/store'

export const getValueFromRecursion = function (tree, key, from) {
  let value
  tree.some(item => {
    if (item[key] === from) {
      value = item
      return true
    }
    if (item.children && item.children.length) {
      let temp = getValueFromRecursion(item.children, key, from)
      if (temp) {
        value = temp
        return true
      }
    }
  })
  if (value) {
    return value
  }
}

export const getObjType = obj => {
  var toString = Object.prototype.toString
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  if (obj instanceof Element) {
    return 'element'
  }
  return map[toString.call(obj)]
}

/**
 * 对象深拷贝
 */
export const deepClone = data => {
  var type = getObjType(data)
  var obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    // 不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key])
    }
  }
  return obj
}



/**
 *加密处理
 */
export const encryption = (params) => {
  let {
    data,
    type,
    param,
    key
  } = params
  const result = JSON.parse(JSON.stringify(data))
  if (type === 'Base64') {
    param.forEach(ele => {
      result[ele] = btoa(result[ele])
    })
  } else {
    key = CryptoJS.enc.Latin1.parse(key)
    var iv = key
    param.forEach(ele => {
      var temp = result[ele]
      // 加密
      var encrypted = CryptoJS.AES.encrypt(
        temp,
        key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.ZeroPadding
        })
      result[ele] = encrypted.toString()
    })
  }
  return result
}

export function getDictLabelFromValue(code, value) {
  let arr = getDictListFromCode(code)
  let label
  arr.some(item => {
    if (item.value === value) {
      label = item.label
      return true
    }
  })

  return label
}

export function getDictListFromCode(code) {
  return store.getters.dictList.filter(item => item.dictCode === code)
}

function getPrice(origin, key) {
  if (!origin) return 0
  if (key) {
    return (origin / key).toFixed(2)
  } else {
    return (origin / 100).toFixed(2)
  }
}

//比较两个时间  time1，time2均为日期类型
//判断两个时间段是否相差 m 个月
export function completeDate(start, end, m) {
  let sY = start.getFullYear();
  let sM = start.getMonth();
  let eY = end.getFullYear();
  let eM = end.getMonth();
  if (Math.abs(sM - eM) < m && Math.abs(sY - eY) === 0) {
    return false;
  } else {
    if ([0, 1, 2, 3, 4].includes(sM) && ((sY - eY) === 1)) {
      let arr = [11, 10, 9, 8, 7];
      let flag = true;
      [0, 1, 2, 3, 4].forEach((item) => {
        if (sM === item) {
          let temp = arr.slice(0, m - sM - 1);
          if (temp.includes(eM)) {
            flag = false;
          }
        }
      });
      return flag;
    }
    if ([7, 8, 9, 10, 11].includes(sM) && ((eY - sY) === 1)) {
      let arr = [0, 1, 2, 3, 4];
      let flag = true;
      [7, 8, 9, 10, 11].forEach((item) => {
        if (sM === item) {
          let temp = arr.slice(0, sM - m);
          if (temp.includes(eM)) {
            flag = false;
          }
        }
      });
      return flag;
    }
    return true;
  }
}

export function compressPhoto(file) {
  return new Promise((resolve => {
    if (file.size / 1024 > 1025) { //大于1M，进行压缩上传
      photoCompress(file, {
        quality: 0.5
      }, function (base64Codes) {
        let temp = dataURLtoFile(base64Codes, file.name)
        resolve(temp)
      });
    } else { //小于等于1M 原图上传
      resolve(file)
    }
  }))
}

export default {
  getDictLabelFromValue,
  getDictListFromCode,
  getPrice
}



// WEBPACK FOOTER //
// ./src/utils/util.js